import { render, staticRenderFns } from "./UserInfoReadonlyInputItem.vue?vue&type=template&id=128ff40e&"
import script from "./UserInfoReadonlyInputItem.vue?vue&type=script&lang=js&"
export * from "./UserInfoReadonlyInputItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QItem,QInput} from 'quasar'
component.options.components = Object.assign({QItem,QInput}, component.options.components || {})
